import { COLOR, SECONDARY_COLOR } from 'src/styles/theme'

export function getGridColsWidth(isFiftyFifty, isTextDominant) {
  let textPart = 0
  let mediaPart = 0

  if (isFiftyFifty) {
    textPart = 6
    mediaPart = 6
  } else if (isTextDominant) {
    textPart = 7
    mediaPart = 5
  } else {
    textPart = 4
    mediaPart = 8
  }
  return { textPart, mediaPart }
}

export const BACKGROUND_COLORS = {
  baker_beach: COLOR.BAKER_BEACH_WHITE,
}

export const VERSION_TYPES = {
  media_dominant: 'media_dominant',
  text_dominant: 'text_dominant',
}
